import { Box } from '@material-ui/core';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';
import { NgpLabelValue } from '../../form/NgpLabelValue';
import {
    AGENT_MODEL_LONG_DISPLAY_FIELD,
    AGENT_WIFI_ERRORS_FIELD,
    AGENT_WIFI_SELECTION_FIELD,
    AGENT_WIFI_SINGLE_SSID_OPTION,
    AGENT_VITALS_WIFI_MAC,
} from './AgentConstants';
import { useColumnStyles } from './AgentStyles';
import {
    MODEL_LABEL_TEXT,
    renderStatusData,
    renderVersionData,
    renderWiFiData,
    renderTxBudgetData,
    STATUS_LABEL_TEXT,
    VERSION_LABEL_TEXT,
    WIFI_ERRORS_LABEL_TEXT,
    WIFI_LABEL_TEXT,
    TX_BUDGET_LABEL_TEXT,
} from './AgentReadOnlyHelper';

export default function AgentReadOnlyPrimary({ agent, agentHasWireless, isGlobalAgent }) {
    const columnClasses = useColumnStyles();
    const { watch } = useFormContext();
    const wifiSelection = watch(AGENT_WIFI_SELECTION_FIELD);

    if (_.isEmpty(agent)) {
        return null;
    }

    const isVirtualAgentWiFi = !agentHasWireless.current && _.get(agent, AGENT_VITALS_WIFI_MAC);
    const renderedStatus = renderStatusData(columnClasses, agent, agentHasWireless.current);
    const renderedVersion = renderVersionData(columnClasses, agent, agentHasWireless.current);
    const renderedWiFi = renderWiFiData(columnClasses, agent, agentHasWireless.current, isVirtualAgentWiFi);
    const rendredTxBudget = renderTxBudgetData(columnClasses, agent, isGlobalAgent.current);

    return (
        <Box mt={1.5} mb={0.5}>
            <NgpLabelValue dataLabel={STATUS_LABEL_TEXT} dataValue={renderedStatus} />
            <NgpLabelValue dataLabel={MODEL_LABEL_TEXT} dataValue={_.get(agent, AGENT_MODEL_LONG_DISPLAY_FIELD)} />
            <NgpLabelValue dataLabel={VERSION_LABEL_TEXT} dataValue={renderedVersion} />
            {(agentHasWireless.current || isVirtualAgentWiFi) && (
                <>
                    <NgpLabelValue dataLabel={WIFI_LABEL_TEXT} dataValue={renderedWiFi} />
                    {wifiSelection === AGENT_WIFI_SINGLE_SSID_OPTION && (
                        <NgpLabelValue
                            dataLabel={WIFI_ERRORS_LABEL_TEXT}
                            dataValue={_.get(agent, AGENT_WIFI_ERRORS_FIELD)}
                        />
                    )}
                </>
            )}
            {isGlobalAgent.current && <NgpLabelValue dataLabel={TX_BUDGET_LABEL_TEXT} dataValue={rendredTxBudget} />}
        </Box>
    );
}
